import type { AccountingPolicy } from '@libs/domain';
import { settlementDateCriteria } from '@libs/enums';
import { dateToStr, getMonthFormatByLocale, getNextYm, getPrevYm, Locale } from '@ps-smart-cp/ppfw-client';

function calcEntryMonth(
  date: Date | null,
  context: Pick<AccountingPolicy['schema'], 'settlementDate' | 'settlementDateBasis'>,
) {
  if (date === null) {
    return '';
  }
  switch (context.settlementDateBasis) {
    case settlementDateCriteria.enum.eom:
      return dateToStr(date, 'yyyy/MM');
    case settlementDateCriteria.enum.one:
      return date.getDate() > Number(context.settlementDate) ? dateToStr(date, 'yyyy/MM') : getPrevYm(date);
    case settlementDateCriteria.enum.two:
      return date.getDate() > Number(context.settlementDate) ? getNextYm(date) : dateToStr(date, 'yyyy/MM');
  }
}

function getEntryMonthByLocale(entryMonth: string, locale: Locale) {
  const year = entryMonth.slice(0, 4);
  const month = Number(entryMonth.slice(5));
  const months = getMonthFormatByLocale(locale);

  if (locale === Locale.en) {
    return `${months[month - 1]}-${year}`;
  }
  return entryMonth;
}

export { calcEntryMonth, getEntryMonthByLocale };
